
import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import Breadcrumb from "@/components/Breadcrumb";
import StructuredData from "@/components/StructuredData";
import DepartmentSEOPage from "@/components/seo/DepartmentSEOPage";
import RequestFormSection from "@/components/location-bennes/RequestFormSection";
import { departmentSEOData } from "@/data/departmentSEOData";
import { departements } from "@/components/location-bennes/LocationData";

const LocationBennesPuyDeDomeSEO = () => {
  const departmentData = departmentSEOData["63"];
  const nearbyDepartments = departements.filter(d => 
    ["15", "43", "42", "03", "23"].includes(d.code)
  );

  const localServiceSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://www.groupefabre-environnement.fr/nos-services/location-bennes/63#business",
    "name": "Groupe Fabre Environnement - Location de bennes Puy-de-Dôme",
    "description": "Service professionnel de location de bennes dans le Puy-de-Dôme. Intervention à Clermont-Ferrand, Riom, Thiers. Métropole clermontoise.",
    "url": "https://www.groupefabre-environnement.fr/nos-services/location-bennes/63",
    "telephone": "+33565787900",
    "email": "contactgfe@groupefabre.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Clermont-Ferrand",
      "addressRegion": "Puy-de-Dôme",
      "postalCode": "63000",
      "addressCountry": "FR"
    },
    "areaServed": [
      {
        "@type": "AdministrativeArea",
        "name": "Puy-de-Dôme",
        "containsPlace": [
          {"@type": "City", "name": "Clermont-Ferrand"},
          {"@type": "City", "name": "Riom"},
          {"@type": "City", "name": "Thiers"},
          {"@type": "City", "name": "Issoire"},
          {"@type": "City", "name": "Cournon-d'Auvergne"}
        ]
      }
    ],
    "serviceType": "Location de bennes et gestion des déchets"
  };

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Location de Bennes Puy-de-Dôme (63) - Clermont-Ferrand, Riom | Groupe Fabre"
        description="Location de bennes dans le Puy-de-Dôme. Service professionnel à Clermont-Ferrand, Riom, Thiers. Métropole, tarifs dès 120€, livraison 24-48h."
        canonical="/nos-services/location-bennes/63"
        keywords="location benne Puy-de-Dôme, benne Clermont-Ferrand, location benne Riom, déchets Puy-de-Dôme, benne métropole, location conteneur 63"
        localBusiness={{
          city: "Clermont-Ferrand",
          region: "Puy-de-Dôme",
          postalCode: "63000",
          serviceType: "Location de bennes"
        }}
      />
      
      <StructuredData data={localServiceSchema} />
      
      <Navbar />
      
      <main className="flex-1 pt-20">
        <nav aria-label="Fil d'Ariane" className="bg-gray-50 py-3 border-b border-gray-200">
          <div className="container mx-auto px-4">
            <Breadcrumb
              items={[
                { label: "Services", href: "/nos-services" },
                { label: "Location de bennes", href: "/nos-services/location-bennes" },
                { label: "Puy-de-Dôme (63)", href: "/nos-services/location-bennes/63", current: true }
              ]}
            />
          </div>
        </nav>

        <article className="py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            <DepartmentSEOPage
              departmentCode="63"
              departmentName="Puy-de-Dôme"
              region="Auvergne-Rhône-Alpes"
              mainCities={["Clermont-Ferrand", "Riom", "Thiers", "Issoire", "Cournon-d'Auvergne"]}
              description="Service de location de bennes dans le Puy-de-Dôme, spécialisé pour la métropole clermontoise."
              heroTitle="Location de bennes dans le Puy-de-Dôme (63)"
              heroSubtitle="Solutions professionnelles pour la métropole de Clermont-Ferrand et tout le département"
              specificServices={[
                "Service métropole Clermont-Ferrand",
                "Bennes pour zones urbaines denses",
                "Solutions industrielles",
                "Gestion déchets universitaires"
              ]}
              localTestimonial={{
                text: "Excellent service pour nos chantiers urbains. Très réactifs et professionnels dans la métropole.",
                author: "Entreprise Clermont-Ferrand",
                city: "Clermont-Ferrand"
              }}
              nearbyDepartments={nearbyDepartments}
            />
            
            <section id="request-form" className="mt-12">
              <RequestFormSection />
            </section>
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
};

export default LocationBennesPuyDeDomeSEO;
